export class ApiErrorFactory {
  static TypeError(expected, actual) {
    return  new Error(`Invalid response. Expected(${expected}) Actual(${actual})`);
  }
}


// WEBPACK FOOTER //
// ./src/core/services/apiErrorFactory.js